import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
// import { iconAnimation, labelAnimation, sidebarAnimation } from 'src/app/animations/animations';
import { User } from 'src/app/_models/user';
import { AuthService } from 'src/app/_services/auth.service';
import { mainContentAnimation } from './animations/animations';
import { SidebarService } from './services/sidebar.service';

@Component({
  selector: 'app-layout',
  templateUrl: './client-layout.component.html',
  styleUrls: ['./client-layout.component.css', './client-layout.component.scss'],
  animations: [
    mainContentAnimation(),
  ]
})
export class ClientLayoutComponent implements OnInit {
  sidebarState = '';

  constructor(
    private sidebarService: SidebarService,
  ) { }

  ngOnInit() {
    this.sidebarService.sidebarStateObservable$
      .subscribe((newState: string) => {
        this.sidebarState = newState;
      });
  }
}
